var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleNum3Blue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.8887,
    r: 16,
    fill: "#1167ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6935 23.0987C13.9385 23.0987 12.7535 22.4387 11.9735 21.5537L13.0085 20.1587C13.6685 20.8037 14.4785 21.2987 15.4835 21.2987C16.6085 21.2987 17.3735 20.7437 17.3735 19.7387C17.3735 18.6587 16.7285 17.9687 14.3135 17.9687V16.3937C16.3535 16.3937 17.0135 15.6887 17.0135 14.6987C17.0135 13.8287 16.4735 13.3187 15.5285 13.3187C14.7335 13.3187 14.0885 13.6787 13.4285 14.2937L12.3035 12.9437C13.2635 12.1037 14.3285 11.5787 15.6335 11.5787C17.7785 11.5787 19.2335 12.6437 19.2335 14.5337C19.2335 15.7337 18.5585 16.6037 17.3885 17.0687V17.1437C18.6335 17.4887 19.5935 18.4187 19.5935 19.8737C19.5935 21.9137 17.8085 23.0987 15.6935 23.0987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleNum3Blue);
export default __webpack_public_path__ + "static/media/icon_circleNum_3_blue.6af56950fab465cafd3b1730ccc19cd2.svg";
export { ForwardRef as ReactComponent };